<template>
  <div class="col-sm-12 col-xl-12">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Basic Dropdown</h3>
      </div>
      <div class="card-body dropdown-basic">
        <div class="dropdown">
          <button class="dropbtn btn-primary" type="button">Dropdown Button <span><i class="icofont icofont-arrow-down"></i></span></button>
          <div class="dropdown-content"><a href="javascript:void(0)">Action</a><a href="javascript:void(0)">Another Action</a><a href="javascript:void(0)">Something Else Here</a></div>
        </div>
      </div>
    </div>
  </div>   
</template>